import { Link } from 'react-router-dom';
import { ScrollSection } from '../components/ScrollSection';

function FAQ() {
  return (
    <>
      <div
        className="container-fluid page-header wow fadeIn"
        data-wow-delay="0.1s"
        style={{
          background: 'linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(/img/faq-vec2.png)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="container text-center py-5 mt-4">
          <h1 className="display-2 text-white fw-bold mb-3 animated slideInDown">Frequently Asked Questions</h1>
          <nav aria-label="breadcrumb animated slideInDown">
            <ol className="breadcrumb justify-content-center mb-0">
              <li className="breadcrumb-item fw-bold">
                <Link to="/" className="text-white">
                  Home
                </Link>
              </li>
              <li className="breadcrumb-item fw-bold text-white" aria-current="page">
                FAQ
              </li>
            </ol>
          </nav>
        </div>
      </div>

      <ScrollSection>
        <div className="container py-5">
        <div className="row">
          <div className="col-lg-12">
            <h2 className="mb-4">Frequently Asked Questions</h2>
            <div className="accordion" id="faqAccordion">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#faq1"
                  >
                    What are your operating hours?
                  </button>
                </h2>
                <div id="faq1" className="accordion-collapse collapse show" data-bs-parent="#faqAccordion">
                  <div className="accordion-body">
                    Tema General Hospital operates 24/7 to provide emergency and inpatient services. Our outpatient
                    departments have specific operating hours which can be obtained by contacting us.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#faq2"
                  >
                    Do you accept health insurance?
                  </button>
                </h2>
                <div id="faq2" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                  <div className="accordion-body">
                    Yes, we accept various health insurance plans. Please check our Corporate Insurance page for a list
                    of accepted insurance providers.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </ScrollSection>
    </>
  );
}

export default FAQ;
